export default class createSitooCredentialsOverlay {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/modal/createSitooCredentials.html'),
            scope: {
                show: '=',
                events: '='
            },
            controller: CreateSitooCredentialsCtrl,
            controllerAs: 'credentials'
        }
    }
};

class CreateSitooCredentialsCtrl {
    constructor($scope, $filter, Setting, Events) {
        this._scope = $scope;
        this._translator = $filter('translate');

        this.settingsRepo = Setting;
        this.eventHandler = Events;
        this.credentials = {};


        $(document).keyup((e) => {
            if (e.keyCode == 27) {
                this._scope.show = false;
                this._scope.$apply(); // Close modal on escape.
            }
        });
    }

    toggleShow() {
        this._scope.show = ! this._scope.show;
    };

    save() {
        if (this.credentials.apiId && this.credentials.password && this.validApiId(this.credentials.apiId)) {
            let accountId = this.credentials.apiId.split('-')[0];
            this.settingsRepo.createSitooCredentials(
                accountId,
                this.credentials.apiId,
                this.credentials.password
            ).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('SITOO:CREATED'));
                this._scope.$emit('setting:newSitooCredentials');
                this.credentials = {};
                this.toggleShow();
            }, (error) => {
                this.eventHandler.flashEvent('error', 'Error')
            });
        } else {
            this.eventHandler.flashEvent('error', this._translator('SITOO:INVALID'));
        }
    }

    validApiId(apiId) {
        let regex = /^([0-9]{1,7}-[0-9]{1,4})(?![0-9A-Za-z-])/;

        return regex.test(apiId);
    }
}
